import { get } from 'lodash';
import { sleep } from './api-helpers';

export function getCJAffliatesClickId() {
  const cookies = document.cookie.split(';').map((row) => row.trim());
  const cookie = cookies.find((row) => row.startsWith('cje='));
  return cookie && cookie.split('=')[1];
}

export async function loadCJAffliatesLibrary() {
  const config = get(window, 'ReactAppEnv.stats.cje');
  const { domain, tagId } = config || {};

  if (!domain || !tagId) {
    return {};
  }

  window.__cjePromise =
    window.__cjePromise ||
    new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = `https://${domain}/tags/${tagId}/tag.js`;
      script.type = 'application/javascript';
      script.async = true;
      script.id = 'cjapitag';
      script.onload = () => resolve({ api: window.cjApi, config });
      document.head.appendChild(script);
    });

  return window.__cjePromise;
}

export function sendCJEOrderEvent(params) {
  const cjeClickId = getCJAffliatesClickId();
  loadCJAffliatesLibrary().then(async ({ api, config }) => {
    // HACK - :( CJ library has an internal issue where the library may not be done
    // initializing. This is effectively what they are doing internally except that
    // there is a bug where the sendOrder method doesn't actually fire after the delay
    await sleep(500);

    api &&
      api.sendOrder &&
      api.sendOrder({
        enterpriseId: config.enterpriseId,
        actionTrackerId: config.actionTrackerIds.order,
        pageType: 'conversionConfirmation',
        cjeventOrder: cjeClickId,
        ...params,
      });
  });
}
